import type { InvoiceConfig } from '#types/config/components/form/invoice'
import type { RecursivePartial } from '#types/utils'

export default {
  companyName: {
    includedLocales: ['it-it', 'pt-pt', 'es-es']
  },
  vatNumber: {
    includedLocales: ['it-it', 'pt-pt', 'es-es'],
    regex: {
      IT: {
        code: /^\d+$/,
        length: 11
      },
      ES: {
        code: /^([np-sw]\d{7}[a-z])|([a-hjuv]\d{8})$/i,
        length: 9
      },
      PT: {
        code: /^5\d*$/,
        length: 9
      }
    }
  },
  pecEmail: {
    includedLocales: ['it-it']
  },
  recipientCode: {
    includedLocales: ['it-it']
  },
  fiscalCode: {
    includedLocales: ['it-it', 'pt-pt', 'es-es'],
    regex: {
      IT: {
        code: /^[a-z]{6}\d{2}[a-z]\d{2}[a-z]\d{3}[a-z]$/i,
        length: 16
      },
      ES: {
        code: /^([klmxyz0-9]\d{7}[a-z])|(x\d{8}[a-z])$/i,
        length: 10
      },
      PT: {
        code: /^[1-3]\d*$/,
        length: 9
      }
    }
  },
  shouldMatchBillingAddressCountry: ['it', 'pt', 'es'],
  shouldShowInvoiceRequiredFieldsPrompt: ['it'],
  countryCodeTranslationList: ['it', 'be', 'gb', 'es', 'fr', 'pt']
} satisfies RecursivePartial<InvoiceConfig>
